var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59993 1H12.3999C13.1333 1 13.7333 1.6 13.7333 2.33333V3.8C13.7333 4.33333 13.3999 5 13.0666 5.33333L10.1999 7.86667C9.79993 8.2 9.53327 8.86667 9.53327 9.4V12.2667C9.53327 12.6667 9.2666 13.2 8.93327 13.4L7.99994 14C7.13327 14.5333 5.93327 13.9333 5.93327 12.8667V9.33333C5.93327 8.86667 5.6666 8.26667 5.39994 7.93333L2.8666 5.26667C2.53327 4.93333 2.2666 4.33333 2.2666 3.93333V2.4C2.2666 1.6 2.8666 1 3.59993 1Z",
    stroke: "#787486",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.902c1766a8e959b6db91256fbd71ae6a.svg";
export { ForwardRef as ReactComponent };